import isEmpty from "lodash/isEmpty";

const encode = (v) => encodeURIComponent(v);

export const convertToQueryString = (filterObj) => {
  if (!filterObj) return null;
  const parts = [];
  Object.keys(filterObj).forEach((key) => {
    const value = filterObj[key];
    if (value === undefined || value === null || value === "") return;
    if (Array.isArray(value)) {
      value.forEach((item) => {
        if (item !== undefined && item !== null && item !== "") {
          parts.push(`${key}=${encode(item)}`);
        }
      });
    } else {
      parts.push(`${key}=${encode(value)}`);
    }
  });
  return parts.length ? parts.join("&") : null;
};

export const convertQuerySearchToObject = (queryString) => {
  var search = queryString.substring(1);

  if (isEmpty(queryString)) {
    return {};
  }

  return JSON.parse(
    '{"' + search.replace(/&/g, '","').replace(/=/g, '":"') + '"}',
    (key, value) => (key === "" ? value : decodeURIComponent(value))
  );
};
